export const categories = $axios => ({
  update: (params = {}) => $axios.$patch('/builder/categories', params),
});
